<template>
  <Card>
  <el-button type="primary" icon="el-icon-printer" class="button-action"
    @click="clickPrint" v-if="listLength">
    Imprimer
  </el-button>
  <el-button type="success" icon="el-icon-document-checked"
    class="button-action" @click="validInventaire" v-if="listLength">
    Clôturer l'inventaire
  </el-button>
  <el-alert
      v-if="hasFamilyEmpty"
      title="Certaines familles de produits sont incomplètes."
      type="error"
      class="alert-has-family-empty"
      :closable="false"
      effect="dark"
      show-icon>
    </el-alert>
  </Card>
</template>

<script>
import Card from '@/components/Card/Card.vue';

export default {
  components: {
    // Inventory,
    Card,
  },
  props: {
    // listLength: { type: Object },
    // productName: { type: String },
    listLength: { type: Boolean, default: false },
    hasFamilyEmpty: { type: Boolean, default: false },
  },
  // data() {
  //   return {
  //     quantityAreaSelling: null,
  //     quantityAreaStock: null,
  //   };
  // },
  // mounted() {
  //   this.quantityAreaSelling = this.product.quantityAreaSelling;
  //   this.quantityAreaStock = this.product.quantityAreaStock;
  //   // this.reception = this.product.reception;
  //   // this.quantity = this.productQuantity;
  // },
  methods: {
    clickPrint() {
      this.$emit('onPrint');
    },
    validInventaire() {
      let text = '';
      let type = 'warning';
      if (this.hasFamilyEmpty) {
        // text = `Certaines familles de produits sont incomplètes.<br/>
        // Vous devez saisir une quantité pour tous les produits
        // identifiés par cette icône <i class="el-icon-star-on icon-can-be-empty"></i>.<br>
        // La quantité saisie ne doit pas être une valeur anormale
        // <i class="el-icon-warning icon-warning"></i>.`;
        text = `Certaines familles de produits sont incomplètes.<br/>
        Vous devez saisir une quantité pour tous les produits.<br>
        La quantité saisie ne doit pas être une valeur anormale
        <i class="el-icon-warning icon-warning"></i>.`;
        type = 'error';
        this.$alert(text, "Impossible de clôturer l'inventaire", {
          confirmButtonText: 'OK',
          type,
          dangerouslyUseHTMLString: true,
          customClass: 'message-box-validate-inv',
        });
      } else {
        this.$confirm(`${text}Etes-vous sûr de vouloir clôturer votre inventaire ?`, 'Attention', {
          confirmButtonText: 'Oui',
          cancelButtonText: 'Non',
          type,
        }).then(() => {
          this.$emit('onValidate');
        }).catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: 'Suppression annulée',
          // });
        });
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.button-action {
  margin: 5px !important;
}
.icon-warning {
  font-size: 20px;
  color: #E6A23C;
}
.message-box-validate-inv {
    width: 440px;
}
</style>
<style scoped lang="stylus">
h3
  margin 40px 0 0

ul
  list-style-type none
  padding 0

li
  display inline-block
  margin 0 10px

a
  color #42b983

.name-product
  margin: 10px;
  display: inline-block;

.unit-product
  margin: 10px;

.container-product
  display: flex;
  flex-direction: row;

.alert-has-family-empty
  padding: 11px 16px;
  margin-left: 5px;

@media (min-width: 945px){
  .alert-has-family-empty {
    display: inline;
  }
}

/* .name-product
  width: 150px; */

.el-col
  border-radius: 4px;

.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
  text-align: right;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 40px;
  padding: 15px;
}
@media (max-width: 991px){
  .bg-purple {
    text-align: left;
  }
}

.el-badge__content
  z-index: 10;
</style>
